export const poiList = (state) => state.poiList;
